import React, { useCallback } from "react";
import dayjs from "dayjs";
import { Badge, Button, Flex, Separator, Text } from "@radix-ui/themes";
import { TenantUserTicket } from "../../entities/TenantUserTicket";
import { TicketCollaborators } from "./TicketCollaborators";
import { ChatSettingsV2 } from "../../entities/ChatSettingsV2";

interface TicketButtonProps {
  ticket: TenantUserTicket;
  onClick: (ticket: TenantUserTicket) => void;
  settings?: ChatSettingsV2;
}

export function TicketButton({ ticket, onClick, settings }: TicketButtonProps) {
  const handleOnClick = useCallback(() => {
    onClick(ticket);
  }, [onClick, ticket]);

  return (
    <Button
      variant="ghost"
      color="gray"
      className="qc-TicketList__Button"
      onClick={handleOnClick}
      aria-label="Open ticket"
    >
      <Flex key={ticket.id} direction="column" gap="1" align={"start"}>
        <Text
          size={"3"}
          color={"gray"}
          weight={"medium"}
          highContrast
          align="left"
        >
          {ticket.subject}
        </Text>

        <Flex gap="3" align="center">
          <Text size={"1"} color={"gray"}>
            {`Open since ${dayjs(ticket.createdAt).format("DD MMM YYYY")}`}
          </Text>

          <Separator orientation="vertical" />

          <Badge
            color="gray"
            variant="soft"
            size="1"
            style={{ textTransform: "capitalize" }}
          >
            {ticket.status}
          </Badge>
        </Flex>

        <TicketCollaborators collaborators={ticket.publicCollaborators} settings={settings} />
      </Flex>
    </Button>
  );
}
